import React from "react"
import types from "prop-types"
import { questionShape } from "utils/propTypeShapes"
import Question from "./Question"

const SectionQuestions = ({ questions, formAnswers }) => (
  questions.map((question) => (
    <Question
      key={question.uuid}
      question={question}
      formAnswers={formAnswers}
    />
  ))
)

SectionQuestions.propTypes = {
  questions: types.arrayOf(questionShape).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  formAnswers: types.object.isRequired,
}

export default SectionQuestions
